import styled from 'styled-components';

export const SectionListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  @media screen and (max-width: 1280px) {
    max-width: 80%;
  }
`;
